import React, { useContext } from "react";
import { ServerListView } from "./container/ServerListView";
import { ApolloProvider } from "@apollo/client";
import { BrowserRouter as Router, Route, Routes, useParams, } from "react-router-dom";
import { AllFeatureAppListView } from "./container/AllFeatureAppListView";
import { ServerView } from "./container/ServerView";
import { FeatureAppView } from "./container/FeatureAppView";
import { AllServiceBundleView } from "./container/AllServiceBundleView";
import { ApplicationContainer } from "./ApplicationContainer";
import { DashboardView } from "./container/DashboardView";
import { ServiceContext, services } from "./context/ServiceContext";
import { View } from "./component/View";
import { MarketListView } from "./container/MarketListView";
import { DeploymentSetView } from "./container/DeploymentSetView";
import { ConfigContext } from "./context/ConfigContext";
import { AppsView } from "./apps/AppsView";
import { AppsListView } from "./apps/AppsListView";
function ServerDetailsRoute() {
    const { serverName = "" } = useParams();
    return (React.createElement(View, { path: "/server/:serverName" },
        React.createElement(ServerView, { envName: serverName })));
}
function FeatureAppRoute() {
    const { appName = "" } = useParams();
    return (React.createElement(View, { path: "/featureapp/:appName" },
        React.createElement(FeatureAppView, { appName: appName })));
}
function DeploymentSetRoute() {
    const { deploymentSet = "" } = useParams();
    return (React.createElement(View, { path: "/deploymentset/:deploymentSet" },
        React.createElement(DeploymentSetView, { deploymentSetName: deploymentSet })));
}
function MarketListRoute() {
    const { serverName = "" } = useParams();
    return (React.createElement(View, { path: "/server/:serverName/market" },
        React.createElement(MarketListView, { envName: serverName })));
}
function AppsRoute() {
    const { appName = "" } = useParams();
    return (React.createElement(View, { path: "/apps/:appName" },
        React.createElement(AppsView, { appName: appName })));
}
export function App() {
    const { client } = useContext(ConfigContext);
    if (!client) {
        throw new Error("no config and no client");
    }
    return (React.createElement(ApolloProvider, { client: client },
        React.createElement(ServiceContext.Provider, { value: services },
            React.createElement(ApplicationContainer, null,
                React.createElement("div", null,
                    React.createElement(Router, null,
                        React.createElement(Routes, null,
                            React.createElement(Route, { path: "/", element: React.createElement(View, { path: "/" },
                                    React.createElement(DashboardView, null)) }),
                            React.createElement(Route, { path: "/server", element: React.createElement(View, { path: "/server" },
                                    React.createElement(ServerListView, null)) }),
                            React.createElement(Route, { path: "/server/:serverName", element: React.createElement(ServerDetailsRoute, null) }),
                            React.createElement(Route, { path: "/featureapp", element: React.createElement(View, { path: "/featureapp" },
                                    React.createElement(AllFeatureAppListView, null)) }),
                            React.createElement(Route, { path: "/serviceBundle", element: React.createElement(View, { path: "/serviceBundle" },
                                    React.createElement(AllServiceBundleView, null)) }),
                            React.createElement(Route, { path: "/apps", element: React.createElement(View, { path: "/apps" },
                                    React.createElement(AppsListView, null)) }),
                            React.createElement(Route, { path: "/featureapp/:appName", element: React.createElement(FeatureAppRoute, null) }),
                            React.createElement(Route, { path: "/deploymentset/:deploymentSet", element: React.createElement(DeploymentSetRoute, null) }),
                            React.createElement(Route, { path: "/server/:serverName/market", element: React.createElement(MarketListRoute, null) }),
                            React.createElement(Route, { path: "/apps/:appName", element: React.createElement(AppsRoute, null) }))))))));
}
